/** @jsxImportSource @emotion/react */
import { memo } from "react";

/**
 * セクション
 * @param {Object} customCss CSS変更用オブジェクト
 * @param {String} children 子要素
 */
const Section = memo(({ children }) => {
  return <section>{children}</section>;
});

export default Section;
